module.exports = __webpack_public_path__ + "static/img/gaozhonglishi14.a39f1bda.jpg";